/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import {
	RangeControl,
} from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockConst from '../constants';
const { hookPrefix } = blockConst;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const {
			rating,
		} = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion
					tabs={ [
						{
							name: 'settings',
							initialOpen: true,
							label: () => {
								return __( 'Settings' );
							},
							cb: () => {
								return (
									<>
										<RangeControl
											label={ __( 'Rating' ) }
											value={ rating }
											onChange={ ( value ) => {
												setAttributes( { rating: value } );
											} }
											min={ 0 }
											max={ 5 }
											step={ .5 } />
									</>
								);
							},
						},
					] }
				/>
			</Fragment>,
		];
	}
);
